import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { Auth } from '../../types'
import * as actions from './actions'

export type State = Auth

const initialState: State = {
  loading: true,
} as State

export default reducerWithInitialState(initialState)
  .case(actions.login, (state, { userId, isAdmin }) => {
    return {
      loading: false,
      userId,
      isAdmin,
      authorized: true,
    }
  })
  .case(actions.loginFailed, () => {
    return {
      loading: false,
      authorized: false,
    }
  })
  .case(actions.logout, () => {
    return {
      loading: false,
      authorized: false,
    }
  })
